import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { addLoyaltyProgramApi } from './addLoyaltyProgram.api'
import addLoyaltyProgramInitialState from './addLoyaltyProgram.initialState'
import { AddLoyaltyProgramErrorResponse, AddLoyaltyProgramRequestPayload } from './addLoyaltyProgram.types'

export const addLoyaltyProgram = createAsyncThunk(
  urls.profile.addLoyaltyProgram,
  async (payload: AddLoyaltyProgramRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await addLoyaltyProgramApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const addLoyaltyProgramSlice = createSlice({
  name: urls.profile.addLoyaltyProgram,
  initialState: addLoyaltyProgramInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addLoyaltyProgram.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(addLoyaltyProgram.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(addLoyaltyProgram.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as AddLoyaltyProgramErrorResponse
        state.success = null
      })
  }
})

export const { actions: addLoyaltyProgramActions, reducer: addLoyaltyProgramReducer } = addLoyaltyProgramSlice
export default addLoyaltyProgramSlice.reducer
